import { AppTemplateType } from "./AppTemplateType";

export const LastAppTemplate = "last-app-template";
export const FirstAppID = "first-app-id";
export const WebAppOnboardingAppId = "webAppOnboardingAppId";
export const WalkthroughApp = "walkthrough-app";
export const DismisssedWalkthroughApp = "dismissed-walkthrough-app";
export const ForkedFromAppId = "forked-from-app-id";
export const FirstSync = "first-sync";
export const UsedPairProgramming = "used-pair-programming";
export const GGTDismissedSyncIntro = "ggt-dismissed-sync-intro";
export const DismissedAppFeatureSummary = "dismissed-app-feature-summary";
export const TabbedNavSeen = "tabbed-nav-seen";
export const ShopifyConnectionTutorialSeen = "shopify-connection-tutorial-seen";
export const TabbedNavOff = "tabbed-nav-off";
export const TabbedNavFeedback = "tabbed-nav-feedback";
export const DismissedBuildingShopifyAppTutorial = "dismissed-building-shopify-app-tutorial";
export const BigCommerceQuickApp = "bigcommerce-quick-app";
export const LastUsedDevStore = "last-used-dev-store";
export const CreatedOnMobile = "created-on-mobile";

/**
 * @deprecated legacy tag, use `ForkedFromAppId` instead, will be removed in the future
 */
const ForkedFromEnvId = "forked-from-env-id";

export const getForkedFromAppId = (tags: string[]) => {
  const forkedFromAppId = tags.find((tag) => tag.startsWith(ForkedFromAppId) || tag.startsWith(ForkedFromEnvId));
  const maybeForkedFromAppId = forkedFromAppId?.split(":")[1];

  if (maybeForkedFromAppId) {
    return BigInt(maybeForkedFromAppId);
  }
};

export const getLastAppType = (tags: string[]) => {
  const appTemplateTag = tags.find((tag) => tag.startsWith(LastAppTemplate));
  const maybeAppTemplate = appTemplateTag?.split(":")[1];

  if (maybeAppTemplate && (Object.values(AppTemplateType) as string[]).includes(maybeAppTemplate)) {
    return maybeAppTemplate as AppTemplateType;
  }
};

export enum AppTag {
  Source = "utm_source",
  Medium = "utm_medium",
  Platform = "utm_platform",
  OrgPref = "org_pref",
  AppPref = "app_pref",
  PlatformPref = "platform_pref",
  Discovery = "discovery",
  Experience = "experience",
  Dismissed = "dismissedActions",
  TechnicalLevel = "technical_level",
}

export const OrgPrefFreelancer = "freelancer";
export const OrgPrefAgency = "agency";
export const OrgPrefMerchant = "merchant";
export const OrgPrefEntrepreneur = "entrepreneur";
export const OrgPrefBrand = "brand";
export const OrgPrefAppDeveloper = "app_developer";

export const AgencyTag = `${AppTag.OrgPref}:${OrgPrefAgency}`;

const AppTagValue = {
  [AppTag.Source]: [],
  [AppTag.Medium]: [],
  [AppTag.Platform]: ["shopify", "backend"],
  [AppTag.OrgPref]: [OrgPrefAgency, OrgPrefBrand, OrgPrefAppDeveloper],
  [AppTag.AppPref]: ["custom", "public", "both", "playing"],
  [AppTag.Discovery]: ["google", "twitter", "youtube", "recommendation", "ad", "blog"],
  [AppTag.TechnicalLevel]: ["full_stack_dev", "frontend_dev", "junior_dev", "citizen_dev"],
  [AppTag.Experience]: ["less_than_one_year", "one_to_three_years", "three_plus_years", "not_developer"],
  [AppTag.PlatformPref]: [
    "airtable",
    "bigcommerce",
    "demandware",
    "discord",
    "facebook",
    "figma",
    "googlesheets",
    "hubspot",
    "klaviyo",
    "magento",
    "mailchimp",
    "msteams",
    "netsuite",
    "salesforce",
    "sendgrid",
    "shopify",
    "slack",
    "squarespace",
    "stripe",
    "twilio",
    "webflow",
    "wix",
    "woocommerce",
    "zendesk",
  ],
  [AppTag.Dismissed]: ["upgradeAACLater"],
} as const;

type TagKey<T extends keyof typeof AppTagValue> = CustomTag | (typeof AppTagValue)[T][number];

// This is a hacky way to get a union-friendly string that doesn't wipe out static string values from a union
type CustomTag = string & { trim?: () => string };

export type OrgPref = TagKey<AppTag.OrgPref>;
export const organizations = AppTagValue[AppTag.OrgPref];

export type AppPref = TagKey<AppTag.AppPref>;
export const applications = AppTagValue[AppTag.AppPref];

export type Discovery = TagKey<AppTag.Discovery>;
export const discoveryOptions = AppTagValue[AppTag.Discovery];

export type Experience = TagKey<AppTag.Experience>;
export const experienceOptions = AppTagValue[AppTag.Experience];

export type PlatformPref = TagKey<AppTag.PlatformPref>;
export const platforms = AppTagValue[AppTag.PlatformPref];
export const nonShopifyPlatforms = AppTagValue[AppTag.PlatformPref].filter((k) => k !== "shopify");

export type TechnicalLevel = TagKey<AppTag.TechnicalLevel>;
export const technicalLevels = AppTagValue[AppTag.TechnicalLevel];
